import {
  berechneAbminderungsfaktor,
  berechneAusnutzung,
  berechneBiegeknickbeanspruchbarkeit,
  berechneKnicken,
  berechnePhi,
} from "../knickenBerechnungen.service";

// FIX total Calc: "teilsicherheitsbeiwertFuerDinEN"
export const berechneKnickenDinEN1993 = (
  knickkoeffizient,
  traggliedDaten,
  dickeWeicheBodenschicht,
  bemessungslast,
  teilsicherheitsbeiwertFuerDinEN
) => {
  let berechneteKnickenWerte = berechneKnicken({
    knickkoeffizient,
    traggliedDaten,
    dickeWeicheBodenschicht,
  });

  let phi_calc = berechnePhi(berechneteKnickenWerte.bezogenerSchlankheitsgrad);

  let abminderungsfaktor = berechneAbminderungsfaktor(
    phi_calc,
    berechneteKnickenWerte.bezogenerSchlankheitsgrad
  );

  let biegeknickbeanspruchbarkeit = berechneBiegeknickbeanspruchbarkeit(
    abminderungsfaktor,
    traggliedDaten?.querschnitt,
    berechneteKnickenWerte.charakteristischeFestigkeit,
    teilsicherheitsbeiwertFuerDinEN
  );

  let ausnutzung = berechneAusnutzung(bemessungslast, biegeknickbeanspruchbarkeit);

  return {
    berechneteKnickenWerte,
    phi_calc,
    abminderungsfaktor,
    biegeknickbeanspruchbarkeit,
    ausnutzung,
  };
};
